/*
  Prefetch stron kolekcji — niweluje 3-4 s TTFB przy przejściu np. ze strony
  głównej na kolekcję Lines. Dwa mechanizmy:

  1. Speculation Rules (Chrome/Edge): przeglądarka sama pobiera HTML linku
     przy najechaniu/dotknięciu (eagerness: moderate).
  2. Fallback (Safari/Firefox) + rozgrzewanie cache: fetch() strony przy
     hover/touchstart oraz — po bezczynności — dla głównych linków kolekcji
     widocznych na stronie. Nawet porzucona odpowiedź rozgrzewa cache
     renderowania Shopify (ciepły TTFB ~0,1 s zamiast 3-4 s).

  Wyłączone na urządzeniach dotykowych, przy Data Saver i bardzo wolnych łączach.
*/
(function () {
  if (window.SelvaPrefetch) return;
  window.SelvaPrefetch = true;

  var conn = navigator.connection || {};
  if (conn.saveData) return;
  if (/(^|-)2g$/.test(conn.effectiveType || '')) return;

  var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (!finePointer) return;

  var done = Object.create(null);
  done[location.pathname] = true;

  function isPrefetchable(a) {
    if (!a || !a.href) return false;
    if (a.origin !== location.origin) return false;
    if (a.pathname.indexOf('/collections/') !== 0) return false;
    if (a.search) return false;
    return !done[a.pathname];
  }

  function warm(path) {
    if (done[path]) return;
    done[path] = true;
    fetch(path, { credentials: 'same-origin' }).catch(function () {});
  }

  var speculationRules = false;
  if (
    typeof HTMLScriptElement !== 'undefined' &&
    HTMLScriptElement.supports &&
    HTMLScriptElement.supports('speculationrules')
  ) {
    speculationRules = true;
    var rules = document.createElement('script');
    rules.type = 'speculationrules';
    rules.textContent = JSON.stringify({
      prefetch: [
        {
          where: { href_matches: '/collections/*' },
          eagerness: 'moderate'
        }
      ]
    });
    document.head.appendChild(rules);
  }

  /*
    Hover/touchstart fallback — w Chrome robią to Speculation Rules,
    tutaj obsługujemy pozostałe przeglądarki (fetch dodatkowo rozgrzewa
    cache Shopify, z czego korzysta też kolejny odwiedzający).
  */
  if (!speculationRules) {
    var onIntent = function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (isPrefetchable(a)) warm(a.pathname);
    };
    document.addEventListener('mouseover', onIntent, { passive: true, capture: true });
    document.addEventListener('touchstart', onIntent, { passive: true, capture: true });
  }

  /*
    Rozgrzanie najważniejszych kolekcji po bezczynności (max 8 linków
    z głównej treści strony) — HTML kolekcji po gzip to ~130 KB, a dzięki
    temu klik w kartę kolekcji trafia w ciepły cache niezależnie od tego,
    jak szybko user kliknie.
  */
  function warmVisibleCollections() {
    var links = document.querySelectorAll(
      'main a[href*="/collections/"], .selva-collections-section__links a[href*="/collections/"]'
    );
    var queue = [];
    for (var i = 0; i < links.length && queue.length < 8; i++) {
      var a = links[i];
      if (isPrefetchable(a) && queue.indexOf(a.pathname) === -1) {
        queue.push(a.pathname);
      }
    }
    /* Po kolei, nie równolegle — bez zalewania serwera ośmioma renderami naraz. */
    queue.forEach(function (path, index) {
      setTimeout(function () { warm(path); }, index * 900);
    });
  }

  function scheduleWarm() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(warmVisibleCollections, { timeout: 6000 });
    } else {
      setTimeout(warmVisibleCollections, 4000);
    }
  }

  if (document.readyState === 'complete') {
    setTimeout(scheduleWarm, 2000);
  } else {
    window.addEventListener('load', function () {
      setTimeout(scheduleWarm, 2000);
    });
  }
})();